module.exports = __webpack_public_path__ + "assets/media/lunch.18598618.mp3";